import type { AdminUser, LocationSnapshot } from "@/types";

export interface UserMapPoint {
  id: string;
  name?: string | null;
  email: string;
  image?: string | null;
  role?: string | null;
  banned?: number | boolean | null;
  latitude: number;
  longitude: number;
  accuracy_meters?: number | null;
  country?: string | null;
  city?: string | null;
  region?: string | null;
  timezone?: string | null;
  observed_at?: number | string | null;
}

function finiteNumber(value: unknown): number | null {
  if (value == null) return null;
  const number = typeof value === "number" ? value : Number(value);
  return Number.isFinite(number) ? number : null;
}

export function userMapPointFromAdminUser(user: AdminUser): UserMapPoint | null {
  const latitude = finiteNumber(user.last_location_latitude);
  const longitude = finiteNumber(user.last_location_longitude);
  if (latitude == null || longitude == null) return null;

  return {
    id: user.id,
    name: user.name,
    email: user.email,
    image: user.image,
    role: user.role,
    banned: user.banned,
    latitude,
    longitude,
    accuracy_meters: finiteNumber(user.last_location_accuracy_meters),
    country: user.last_location_country ?? null,
    city: user.last_location_city ?? null,
    region: user.last_location_region ?? null,
    timezone: user.last_location_timezone ?? null,
    observed_at: user.last_location_at ?? null,
  };
}

export function userMapPointFromLocation({
  user,
  location,
}: {
  user: Pick<AdminUser, "id" | "name" | "email" | "image" | "role" | "banned">;
  location: LocationSnapshot | null | undefined;
}): UserMapPoint | null {
  const latitude = finiteNumber(location?.latitude);
  const longitude = finiteNumber(location?.longitude);
  if (latitude == null || longitude == null) return null;

  return {
    id: user.id,
    name: user.name,
    email: user.email,
    image: user.image,
    role: user.role,
    banned: user.banned,
    latitude,
    longitude,
    accuracy_meters: finiteNumber(location?.accuracy_meters),
    country: location?.location_country ?? location?.country ?? null,
    city: location?.city ?? null,
    region: location?.region ?? null,
    timezone: location?.timezone ?? null,
    observed_at: location?.observed_at ?? location?.created_at ?? null,
  };
}
